/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PutClusterCurrencyBody = {
  currency: string;
};

/** @internal */
export const PutClusterCurrencyBody$inboundSchema: z.ZodType<
  PutClusterCurrencyBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  currency: z.string(),
});
/** @internal */
export type PutClusterCurrencyBody$Outbound = {
  currency: string;
};

/** @internal */
export const PutClusterCurrencyBody$outboundSchema: z.ZodType<
  PutClusterCurrencyBody$Outbound,
  z.ZodTypeDef,
  PutClusterCurrencyBody
> = z.object({
  currency: z.string(),
});

export function putClusterCurrencyBodyToJSON(
  putClusterCurrencyBody: PutClusterCurrencyBody,
): string {
  return JSON.stringify(
    PutClusterCurrencyBody$outboundSchema.parse(putClusterCurrencyBody),
  );
}
export function putClusterCurrencyBodyFromJSON(
  jsonString: string,
): SafeParseResult<PutClusterCurrencyBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PutClusterCurrencyBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PutClusterCurrencyBody' from JSON`,
  );
}
